<template>
  <v-card class="mb-4">
    <v-card-title class="d-flex align-center">
      <v-icon class="mr-2" color="purple">mdi-chart-line</v-icon>
      {{ t.dashboard?.traffic_stats || 'Traffic Statistics' }}
      <v-spacer />
      <v-btn
        icon
        size="small"
        variant="text"
        :loading="rebuilding"
        @click="rebuildStats"
        :title="t.dashboard?.recalculate_stats || 'Recalculate statistics'"
        class="mr-2"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
      <v-btn variant="text" size="small" color="purple" to="/reports/traffic">
        {{ t.dashboard?.view_reports || 'View reports' }}
        <v-icon end>mdi-arrow-right</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-progress-circular v-if="loading" indeterminate size="24" class="mr-2" />

      <template v-else-if="errorMessage">
        <v-alert type="warning" variant="tonal" density="compact">{{ errorMessage }}</v-alert>
      </template>

      <template v-else>
        <TrafficSummaryCards :stats="stats" class="mb-4" />
        <TrafficChart :summaries="summaries" />
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { t as tRef } from '@/composables/useLanguages'
import { getTrafficStats, getTrafficSummary } from '@/composables/useTrafficAPI'
import { rebuildClientStatistics } from '@/composables/useDisplaySettingsAPI'
import TrafficSummaryCards from '@/components/traffic/TrafficSummaryCards.vue'
import TrafficChart from '@/components/traffic/TrafficChart.vue'
import store from '@/store'

export default {
  name: 'TrafficStatsSection',
  components: { TrafficSummaryCards, TrafficChart },
  props: {
    config: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      stats: {},
      summaries: [],
      loading: true,
      errorMessage: null,
      rebuilding: false
    }
  },
  computed: {
    t() { return tRef.value },
    token() {
      return store.getters.getToken
    }
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    async loadData() {
      this.loading = true
      this.errorMessage = null
      try {
        const today = new Date()
        const last30 = new Date()
        last30.setDate(today.getDate() - 30)

        const formatDate = (d) => d.toISOString().split('T')[0]

        const [statsResult, summaryResult] = await Promise.all([
          getTrafficStats(this.token),
          getTrafficSummary(this.token, {
            periodType: 'daily',
            startDate: formatDate(last30),
            endDate: formatDate(today)
          })
        ])

        if (!statsResult.error) {
          this.stats = statsResult.stats || {}
        }
        if (!summaryResult.error) {
          this.summaries = summaryResult.summaries || []
        }
      } catch (e) {
        this.errorMessage = this.t.dashboard?.traffic_load_error || 'Error loading traffic data'
      } finally {
        this.loading = false
      }
    },
    async rebuildStats() {
      this.rebuilding = true
      try {
        await rebuildClientStatistics(this.token)
        setTimeout(() => this.loadData(), 2000)
      } finally {
        this.rebuilding = false
      }
    }
  }
}
</script>
